<template>
  <div>
    <b-alert
      variant="danger"
      show
    >
      <div class="alert-body">
        <small>El sistema requiere de un <b>mínimo de fechas cargadas</b>, esto es necesario para el buen funcionamiento en varios procesos de registro, calificación u otros. <b>Verifique que tenga como mínimo los siguientes tipos de eventos calendarizados:</b></small>
      </div>
    </b-alert>

    <div class="px-75">
      <b-skeleton-wrapper :loading="loadingTypes">
        <!-- Loader -->
        <template #loading>
          <b-row>
            <b-col
              v-for="i in 7"
              :key="i"
              lg="6"
              md="12"
            >
              <b-skeleton
                class="mb-50"
                :width="`${Math.floor(Math.random() * (100 - 25 + 1)) + 25}%`"
              />
            </b-col>
          </b-row>
        </template>
        <b-row>
          <b-col
            v-for="tipo in minimum"
            :key="tipo.id"
            lg="6"
            md="12"
          >
            <span
              v-b-tooltip.hover.left="calendario.find(element => element.tipo === tipo.id) ? 'Ya cargó un evento de este tipo' : 'No se ha cargado ningún evento'"
              :style="calendario.find(element => element.tipo === tipo.id) ? 'text-decoration: line-through;' : ''"
              class="cursor-default"
            >
              <feather-icon
                :class="calendario.find(element => element.tipo === tipo.id) ? 'text-primary' : 'text-muted'"
                icon="CheckCircleIcon"
              />
              <span
                class="ml-50"
                :class="calendario.find(element => element.tipo === tipo.id) ? 'text-primary' : 'text-muted'"
              >{{ tipo.nombre }}</span>
            </span>
          </b-col>
        </b-row>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import {
  BAlert,
  BRow,
  BCol,
  BSkeletonWrapper,
  BSkeleton,
  VBTooltip,
} from 'bootstrap-vue'
import {
  computed,
} from '@vue/composition-api'

export default {
  components: {
    BAlert,
    BRow,
    BCol,
    BSkeletonWrapper,
    BSkeleton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    loadingTypes: {
      type: Boolean,
      default: false,
    },
    tipos: {
      type: Array,
      default: () => [],
    },
    calendario: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const minimum = computed(() => props.tipos.filter(item => [2, 3, 9, 10, 11, 12, 13].find(element => element === item.id)))

    return {
      minimum,
    }
  },
}
</script>
